import { render, staticRenderFns } from "./UploadImages.vue?vue&type=template&id=4c25bb18&scoped=true"
import script from "./UploadImages.vue?vue&type=script&lang=js"
export * from "./UploadImages.vue?vue&type=script&lang=js"
import style0 from "./UploadImages.vue?vue&type=style&index=0&id=4c25bb18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c25bb18",
  null
  
)

export default component.exports